import { API_ERRORS } from 'constants/api';

const MAX_MESSAGE_LENGTH = 300;

const MESSAGE_BY_NON_HTTP_STATUS = {
  FETCH_ERROR: API_ERRORS.NETWORK,
  TIMEOUT_ERROR: API_ERRORS.TIMEOUT,
  PARSING_ERROR: API_ERRORS.DEFAULT,
};

const isRenderableMessage = (value) => value.length <= MAX_MESSAGE_LENGTH && !value.trimStart().startsWith('<');

const getFirstMessage = (value) => {
  if (typeof value === 'string') {
    return isRenderableMessage(value) ? value : '';
  }

  if (Array.isArray(value) || (value && typeof value === 'object')) {
    return Object.values(value).reduce((message, item) => message || getFirstMessage(item), '');
  }

  return '';
};

export const getApiErrorMessage = (error, fallback = API_ERRORS.DEFAULT) => {
  if (!error) {
    return '';
  }

  return MESSAGE_BY_NON_HTTP_STATUS[error.status] || getFirstMessage(error.data) || fallback;
};
